export const isGiftCardSingle = (giftCard) => 'id' in giftCard;
